export const MAX_VISIBLE_REWARDS_COUNT = 3
export const MAX_VISIBLE_REWARDS_WITH_ALL_BUTTON = 2
